"use client";

import { c as _c } from "react/compiler-runtime";
import { useCart } from "@/queries/useCart";
import { CartItem } from "./CartItem";
export function CartItemList() {
  const $ = _c(6);
  const {
    data: cart
  } = useCart();
  let t0;
  if ($[0] !== cart?.items) {
    t0 = cart?.items ?? [];
    $[0] = cart?.items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const items = t0;
  let t1;
  if ($[2] !== items) {
    t1 = items.map(_temp);
    $[2] = items;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <>{t1}</>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(item) {
  return <CartItem key={item.id} item={item} />;
}